import { ReactNode } from 'react';

import { useAuth } from '@shared/common/providers/AuthProvider';

import { ConnectWalletButton } from './ConnectWalletButton';

type Props = {
  children: ReactNode;
  placeholder?: ReactNode;
};

export const ConnectWalletGuard = ({ children, placeholder }: Props) => {
  const { userEvmWallet } = useAuth();

  return userEvmWallet ? children : placeholder ?? <ConnectWalletButton />;
};
